import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'

const createWebsocketLink = (subscriptionUri, getAccessToken) =>
  new GraphQLWsLink(
    createClient({
      url: subscriptionUri,
      connectionParams: () => ({
        accessToken: getAccessToken(),
      }),
    }),
  )

export default createWebsocketLink
